import {useState, useEffect} from 'react';

export default function useKeyPress(targetKey: string): [boolean, React.Dispatch<React.SetStateAction<boolean>>] {
  const [keyPressed, setKeyPressed] = useState<boolean>(false);
  const downHandler = ({ key }: KeyboardEvent) => {
    if (key === targetKey) {
      setKeyPressed(true);
    }
  }

  const upHandler = ({ key }: KeyboardEvent) => {
    if (key === targetKey) {
      setKeyPressed(false);
    }
  };

  useEffect(() => {
    window.addEventListener("keypress", downHandler);
    window.addEventListener("keyup", upHandler);
    return () => {
      window.removeEventListener("keypress", downHandler);
      window.removeEventListener("keyup", upHandler);
    };
  }, []);
  return [keyPressed, setKeyPressed];
}